// src/components/safety/SafariHydrationGuard.tsx
"use client";

import { useEffect, useState } from "react";
import { isSafari } from "../../utils/browser/isSafari";

type Props = {
  children: React.ReactNode;
};

export default function SafariHydrationGuard({ children }: Props) {
  const [ready, setReady] = useState(!isSafari());

  useEffect(() => {
    if (!isSafari()) return;

    // Wait one tick to ensure hydration
    const id = requestAnimationFrame(() => {
      setReady(true);
    });

    return () => cancelAnimationFrame(id);
  }, []);

  if (!ready) {
    // Minimal fallback (same background, no freeze)
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#0b3c6d", // same blue background
        }}
      />
    );
  }

  return <>{children}</>;
}
